import axios, { AxiosRequestConfig } from 'axios';
import { getCookie } from 'utils/cookie';

export const defaultAxiosConfig = axios.create({
  withCredentials: true,
  withXSRFToken: true,
  timeout: 60000,
  headers: {
    'content-Type': 'application/json',
    Accept: '/',
    'Cache-Control': 'no-cache',
  },
});

export const getAcessToken = (request: AxiosRequestConfig<unknown>) => {
  const accessToken = getCookie('_TOKEN_BFF');

  if (accessToken) {
    request.headers = {
      ...request.headers,
      Authorization: `Bearer ${accessToken}`,
    };
  }
  return request;
};
